(function () {
  'use strict'
  const param = {
    maskMode: 'no-mask',
    recordCanvas: false,
    projectId: 'wxc7d66f0f80d04243-JEiFZWhFk-5oyzUa',
    iframe: false,
    console: true,
    network: true
  }
  const supportESModule = 'noModule' in document.createElement('script')
  const SCRIPT_URLs = [
    supportESModule
      ? 'https://dev.weixin.qq.com/platform-console/proxy/assets/tel/px.min.js'
      : 'https://dev.weixin.qq.com/platform-console/proxy/assets/tel/px.es5.min.js'
  ]
  function loadScript (url) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = url
      s.onload = () => resolve(url)
      s.onerror = () => reject(new Error('Script load error'))
      document.head.appendChild(s)
    })
  }
  async function main () {
    try {
      sessionStorage.setItem('wxobs_start_timestamp', String(Date.now()))
      await Promise.race(SCRIPT_URLs.map(u => loadScript(u)))
      window.__startPX && window.__startPX(param)
    } catch (e) {
      console.error('Error loading scripts:', e)
    }
  }
  main()
})()
